//输入控件
import React, { Component } from 'react';
import tools from '../utils/tools';
import './ComboBox.less';

class ComboBox extends Component {

  //构造函数
  constructor(props, context) {
    //写构造方法时  必须实现父类的构造方法  否则构造失败  报错
    super(props, context);
  }
  /*================自定义事件====================*/

  renderContent() {
    const { IsFreeItem, dataSource, value } = this.props;
    if (!dataSource) {
      return null;
    }
    const selectValue = IsFreeItem ? value : value ? value.ID : -1;
    return dataSource.map(item => {
      let className = item.ID == selectValue ? 'select' : '';
      return (<div className={className}><span onClick={this.itemClick} data-value={item.ID} >{item.Name}</span></div>);
    });
  }

  itemClick = (e) => {
    tools.preventEvent(e);
    if(this.props.templateItem && this.props.templateItem.ReadOnly === true){
      return;
    }
    const { value } = this.props;
    const { onChange } = this.props;
    const { IsFreeItem, dataSource } = this.props;

    const oldValue = IsFreeItem ? value : value ? value.ID : -1;
    let selectValue = e.target.attributes['data-value'].value
    selectValue = oldValue == selectValue ? '':selectValue;

    if (IsFreeItem) {
      if (onChange)
        onChange(selectValue);
    } else {

      dataSource.forEach(item => {
        if (item.ID == selectValue) {
          if (onChange)
            onChange(item);
        }
      })
    }
  }

  render() {
    return (<div className='comboBox'>{this.renderContent()}</div>);
  }
}
export default ComboBox;
